import React from 'react';
import { Typography } from './util';
import { ContentTag } from './util/Element';
const SPAN = (props) => React.createElement(Typography, { ...props, type: ContentTag.SPAN });
export default SPAN;
//# sourceMappingURL=SPAN.js.map